module.exports = __webpack_public_path__ + "static/media/promo.f845278e.png";